import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6aa0a3eb&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style1 from "./detail.vue?vue&type=style&index=1&id=6aa0a3eb&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa0a3eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aa0a3eb')) {
      api.createRecord('6aa0a3eb', component.options)
    } else {
      api.reload('6aa0a3eb', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=6aa0a3eb&scoped=true", function () {
      api.rerender('6aa0a3eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/serve/detail.vue"
export default component.exports